import { imagePreviewActionTypes } from './constants';

import type { ImagePreviewActions, ImagePreviewState, SetImagePreviewAction } from './types';

const initialState: ImagePreviewState = {
	open: false,
	imageSrc: null,
};

export default function imagePreviewReducer(state = initialState, action: ImagePreviewActions): ImagePreviewState {
	switch (action.type) {
		case imagePreviewActionTypes.SET_IMAGE_PREVIEW: {
			const { data } = (action as SetImagePreviewAction).payload;
			return { ...state, ...data };
		}

		default:
			return state;
	}
}
